import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { useApiQuery } from './useApiQuery';

export const RESOURCE_QUERY_KEYS = {
  photos: 'photoResources',
  videos: 'videoResources',
  'video-message': 'videoMessageResources',
};

export const getResourcesQueryKey = ({ resourceType, useruuid, shared = false }) => [
  RESOURCE_QUERY_KEYS[resourceType],
  useruuid,
  shared,
];

const useResourcesByType = ({ useruuid, resourceType, shared = false, details = false }) => {
  const trans = useSelector(translator);
  const resourcesApi = useSelector((state) => state.apis.resourcesApi);

  return useApiQuery(
    getResourcesQueryKey({ resourceType, useruuid, shared }),
    () =>
      new Promise((resolve, reject) => {
        if (!resourcesApi) {
          reject(new Error('Resources API not available'));
          return;
        }

        resourcesApi.getResources(
          useruuid,
          resourceType,
          details,
          {},
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              const resources = Array.isArray(data?.info)
                ? data.info
                : Array.isArray(data)
                  ? data
                  : [];

              resolve(resources);
            },
            errorCallback: (error) => {
              console.error(`Error fetching ${resourceType}:`, error);
              reject(error);
            },
          })
        );
      }),
    {
      enabled: !!useruuid && !!resourcesApi,
      staleTime: 0,
      gcTime: 5 * 60 * 1000,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
    }
  );
};

export default useResourcesByType;
